import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import adminRouter from "@/views/Admins/admins-routes/index";
import { authorizationGuard, permissionsGuard } from "./routes-guards";
import clientRouter from "@/views/Clients/clients-routes";
import brandRouter from "@/views/Brands/brand-routes";
import modelRouter from "@/views/Models/model-routes";
import truckRouter from "@/views/Truck/truck-routes";
import clientOnSiteRouter from "@/views/ClientsOnSite/clients-on-site-routes";
import manufacturerRouter from "@/views/Manufacturer/manufacturer-routes";
import engineModelRouter from "@/views/EngineModels/engine-model-routes";
import sellerRouter from "@/views/Sellers/sellers-routes";
import salesRouter from "@/views/Sales/sales-routes";
import bookingsRouter from "@/views/Bookings/bookings-routes";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/auth",
    name: "auth",
    component: () => import("@/views/Login.vue"),
    meta: {
      requiresLogged: true
    }
  },
  {
    path: "/home",
    component: () => import("@/views/Home.vue"),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "admins",
        component: () => import("@/views/Admins/AdminView.vue"),
        children: adminRouter
      },
      {
        path: "sellers",
        component: () => import("@/views/Sellers/SellerView.vue"),
        children: sellerRouter
      },
      {
        path: "sales",
        component: () => import("@/views/Sales/SaleView.vue"),
        children: salesRouter
      },
      {
        path: "clients",
        component: () => import("@/views/Clients/ClientView.vue"),
        children: clientRouter
      },
      {
        path: "clients_on_site",
        component: () => import("@/views/ClientsOnSite/ClientOnSiteView.vue"),
        children: clientOnSiteRouter
      },
      {
        path: "brands",
        component: () => import("@/views/Brands/BrandView.vue"),
        children: brandRouter
      },
      {
        path: "models",
        component: () => import("@/views/Models/ModelView.vue"),
        children: modelRouter
      },
      {
        path: "engines",
        component: () => import("@/views/EngineModels/ModelView.vue"),
        children: engineModelRouter
      },
      {
        path: "manufacturers",
        component: () => import("@/views/Manufacturer/ManufacturerView.vue"),
        children: manufacturerRouter
      },
      {
        path: "trucks",
        component: () => import("@/views/Truck/TruckView.vue"),
        children: truckRouter
      },{
        path: "bookings",
        component: () => import("@/views/Bookings/BookingsView.vue"),
        children: bookingsRouter
      },
      {
        path: "",
        name: "default",
        redirect: "clients"
      }
    ]
  },
  { path: "", redirect: "/auth" }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(authorizationGuard);
router.beforeEach(permissionsGuard);

export default router;
